import React from "react";
import { aboutPoints } from "../data/siteContent";

function AboutUs() {
  return (
    <section id="about" className="about section">
      <div className="container section-title" data-aos="fade-up">
        <h2>About Us</h2>
        <p>
          Operating Software is a product-minded software company building for
          both client operations and our own long-term ventures.
        </p>
      </div>

      <div className="container">
        <div className="row gy-4 align-items-center">
          <div
            className="col-lg-6 content"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <p>
              We care about useful software. That means understanding the
              business, reducing unnecessary complexity, and shipping solutions
              that teams can actually rely on.
            </p>
            <ul>
              {aboutPoints.map((point) => (
                <li key={point}>
                  <i className="bi bi-check2-circle"></i>
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
            <div className="about-highlight-card">
              <h3>How we work</h3>
              <p>
                We blend client delivery with in-house product building, which
                gives us a practical view of architecture, timelines,
                iteration, and maintenance.
              </p>
              <p>
                Whether we are supporting a client engagement or shaping a new
                internal platform, the goal stays the same: build software that
                solves a real problem and can keep growing.
              </p>
              <a href="#contact" className="read-more">
                <span>Talk to us</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
